<template>
  <v-sheet
    color="#F8F8F8"
    class="primary--text pa-3"
  >
    <div class="text-body-1 font-weight-medium">
      Baza plików
    </div>
    <v-list
      v-if="allFiles.length"
      color="#F8F8F8"
      :style="`max-height: ${listHeight}px`"
      class="file-list"
    >
      <v-list-item
        v-for="file in allFiles"
        :key="'file'+file.id"
        class="file-row"
      >
        <div class="w-100 d-flex align-center">
          <v-checkbox
            v-model="selectedFiles"
            :value="file.id"
            :disabled="file.removed"
            :indeterminate="file.removed"
            class="mt-0 pt-0 mr-2"
            hide-details
          />
          <a
            :href="!file.removed && file.url"
            target="_blank"
            :download="file.filename"
          >
            <div
              v-if="isImageFile(file)"
              class="project-avatar acceptance-avatar"
              :style="`background-image: url(${getUrl(file.url)})`"
            />
            <img
              v-else
              class="acceptance-avatar"
              :src="require(`@/assets/img/file-icon_${getFileFormat(file)}.svg`)"
            >
          </a>

          <div
            class="file-row__name"
            :class="{'red--text text--darken-4': file.removed}"
          >
            {{ file.filename }}
          </div>
        </div>
      </v-list-item>
    </v-list>
    <AppEmptyList
      v-else
      key="emptyList"
      class="my-10"
      header="Brak plików projektu."
      text="Do projektu nie dodano żadnego pliku."
    />
  </v-sheet>
</template>

<script>
import utils from '@/helpers/utils';
import checkFileExtension from '@/mixins/checkFileExtension.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';

export default {
  props: {
    allFiles: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  mixins: [checkFileExtension], // getFileFormat, isImageFormat
  components: {
    AppEmptyList,
  },
  data: () => ({
    selectAllFiles: false,
  }),
  computed: {
    selectedFiles: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    listHeight() {
      return utils.getResponsiveValues.call(this, 652, 444, 500, 300, 100);
    },
  },
  methods: {
    getUrl(url) {
      return encodeURI(url).replace(/[!'()*]/g, (c) => `%${ c.charCodeAt(0).toString(16)}`);
      // encodeURI does not encode parentheses
    },
  },
};
</script>r

<style lang="scss" scoped>
.acceptance-avatar {
  width:32px;
  height: 32px;
  background-size: cover;
  margin-right:8px;
}
.file-list {
  overflow-y: auto;
}
.file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom:1px solid $secondary;
  box-sizing: content-box;
  border-left:3px solid transparent;
  &--selected {
    border-left:3px solid $golden;
  }
  &__name {
    max-width: 224px;
    @include full-hd {
      max-width: 420px;
    }
  }
}
</style>
